import {configureStore} from "@reduxjs/toolkit";
import authReducer from "../reducer/authReducer.ts";
import apiTokenMiddleware from "../middleware/apiTokenMiddleware.ts";
import pricingReducer from "../reducer/pricingReducer";
import contractReducer from "../reducer/contractReducer";
import productReducer from "../reducer/productReducer.ts";
import navigationReducer from "../reducer/navigationReducer.ts";
import overviewFiltersReducer from "../reducer/overviewFiltersReducer.ts";
import mailServerHealthReducer from "../reducer/mailServerHealthReducer.ts";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorageEngine from "redux-persist/lib/storage/session";

// Catalog/garage selection persists to localStorage (cross-page context the
// user expects to return to across sessions). Pagination/sort stay in the URL.
const productPersistConfig = {
    key: "product",
    storage,
};

const persistedProductReducer = persistReducer(productPersistConfig, productReducer);

// Overview filters persist to sessionStorage: they survive a reload and an
// in-app round-trip into a detail page, but are dropped when the tab closes.
const overviewFiltersPersistConfig = {
    key: "overviewFilters",
    storage: sessionStorageEngine,
};

const persistedOverviewFiltersReducer = persistReducer(overviewFiltersPersistConfig, overviewFiltersReducer);

export const store = configureStore({
    reducer: {
        auth: authReducer,
        pricing: pricingReducer,
        contract: contractReducer,
        product: persistedProductReducer,
        navigation: navigationReducer,
        overviewFilters: persistedOverviewFiltersReducer,
        mailServerHealth: mailServerHealthReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        },
    }).concat(apiTokenMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
